import api from '@/services/api'

const moduleCars = {
  state: {},
  mutations: {},
  actions: {
    CARS_REQUEST: ({ commit }) => {
      return new Promise((resolve, reject) => { // Возвращаем промис для продолжения "цепочки" запросов
        api.get('cars/')
        .then(response => resolve(response))
        .catch(error => reject(error))
      })
    },
    CARS_BY_ROUTE_REQUEST: ({ commit }, id) => {
      return new Promise((resolve, reject) => { // Возвращаем промис для продолжения "цепочки" запросов
        api.get(`routes/${id}/vehicles/`)
        .then(response => resolve(response))
        .catch(error => reject(error))
      })
    }
  },
  getters: {}
}
export default moduleCars